/**
 * Similar ao `index` do jQuery, exceto que ele **não** aceita nenhum argumento.
 * @see https://api.jquery.com/index/
 */
$.fn.index = function() {
  return [].slice.call(this[0].parentNode.children).indexOf(this[0]);
};
